<h2 mat-dialog-title>{{ data.email }}</h2>

<mat-dialog-content>
	@if (loading()) {
		<div class="spinner-wrap">
			<mat-spinner diameter="32" />
		</div>
	} @else {
		@if (userGroups().length > 0) {
			<mat-list>
				@for (group of userGroups(); track group.groupName) {
					<mat-list-item>
						<span matListItemTitle>{{ group.groupName }}</span>
						<button matListItemMeta mat-icon-button (click)="removeGroup(group.groupName)">
							<mat-icon color="warn">remove_circle_outline</mat-icon>
						</button>
					</mat-list-item>
				}
			</mat-list>
		} @else {
			<p class="no-groups" i18n="@@NoGroupsAssigned">No groups assigned.</p>
		}

		@if (availableGroups().length > 0) {
			<div class="add-group-row">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="group-select">
					<mat-label i18n="@@AddToGroup">Add to group</mat-label>
					<mat-select [value]="selectedGroupName()" (valueChange)="selectedGroupName.set($event)">
						@for (group of availableGroups(); track group.groupName) {
							<mat-option [value]="group.groupName">{{ group.groupName }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
				<button mat-icon-button color="primary" (click)="addGroup()" [disabled]="!selectedGroupName() || adding()">
					@if (adding()) {
						<mat-spinner diameter="20" />
					} @else {
						<mat-icon>add</mat-icon>
					}
				</button>
			</div>
		}
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="dialogRef.close()" i18n="@@Close">Close</button>
</mat-dialog-actions>
